const dotNetLang = 'DOTNET';
const javaLang = 'JAVA';
const OTEL_SUB_TYPE = 'O';

export { dotNetLang, javaLang, OTEL_SUB_TYPE };
